var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85279 17.7056C13.742 17.7056 17.7056 13.742 17.7056 8.85279C17.7056 3.96353 13.742 0 8.85279 0C3.96353 0 0 3.96353 0 8.85279C0 13.742 3.96353 17.7056 8.85279 17.7056ZM8.85279 13.279C11.2974 13.279 13.2792 11.2973 13.2792 8.85264C13.2792 6.40801 11.2974 4.42624 8.85279 4.42624C6.40815 4.42624 4.42639 6.40801 4.42639 8.85264C4.42639 11.2973 6.40815 13.279 8.85279 13.279Z",
    fill: "#009D81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9847 17.7056C35.874 17.7056 39.8375 13.742 39.8375 8.85279C39.8375 3.96353 35.874 0 30.9847 0C26.0955 0 22.132 3.96353 22.132 8.85279C22.132 13.742 26.0955 17.7056 30.9847 17.7056ZM30.9847 13.279C33.4294 13.279 35.4111 11.2973 35.4111 8.85264C35.4111 6.40801 33.4294 4.42624 30.9847 4.42624C28.5401 4.42624 26.5583 6.40801 26.5583 8.85264C26.5583 11.2973 28.5401 13.279 30.9847 13.279Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9847 39.8377C35.874 39.8377 39.8375 35.8741 39.8375 30.9849C39.8375 26.0956 35.874 22.1321 30.9847 22.1321C26.0955 22.1321 22.132 26.0956 22.132 30.9849C22.132 35.8741 26.0955 39.8377 30.9847 39.8377ZM30.9847 35.4114C33.4294 35.4114 35.4111 33.4297 35.4111 30.985C35.4111 28.5404 33.4294 26.5586 30.9847 26.5586C28.5401 26.5586 26.5583 28.5404 26.5583 30.985C26.5583 33.4297 28.5401 35.4114 30.9847 35.4114Z",
    fill: "#E34322"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85279 39.8377C13.742 39.8377 17.7056 35.8741 17.7056 30.9849C17.7056 26.0956 13.742 22.1321 8.85279 22.1321C3.96353 22.1321 0 26.0956 0 30.9849C0 35.8741 3.96353 39.8377 8.85279 39.8377ZM8.85279 35.4114C11.2974 35.4114 13.2792 33.4297 13.2792 30.985C13.2792 28.5404 11.2974 26.5586 8.85279 26.5586C6.40815 26.5586 4.42639 28.5404 4.42639 30.985C4.42639 33.4297 6.40815 35.4114 8.85279 35.4114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.bad2340a5a1b0257acfff3f7c9135aeb.svg";
export { ForwardRef as ReactComponent };